<template>
  <div style="height: 100vh;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div>
      <div style="display: flex;justify-content: space-between;">
        <div id="form" style="margin-top: 5px; margin-left: 10px; display: flex;align-items: center;">
          <div @click="dialogVisible_one = true"
            style="    width: 80px;height: 30px;line-height:30px;cursor: pointer;display: flex;border: 1px solid #589ff9;margin-left:10px;justify-content: center;border-radius: 5px;margin-right: 10px;">
            <span style="font-size: 14px">filter</span>
          </div>
          <el-date-picker v-if="value2 && value2.length" v-model="value2" type="daterange" start-placeholder="搜索日期"
            value-format="timestamp" end-placeholder="搜索结束日期" align="right" :picker-options="pickerOptions" size="mini"
            format="yyyy-MM-dd" range-separator="-" style="width: 240px;margin-left:5px" @change="getList"
            class="border_box" :class="{ 'your-css-class': !isValue2Empty }">
          </el-date-picker>
          <el-input v-if="initial_term" style="width: 117px;margin-left:5px" size="mini" placeholder="当初精准确认"
            class="border_box" clearable @change="getList" v-model="initial_term"
            :class="initial_term == '' ? 'blue' : 'orange'"></el-input>

          <el-input v-if="current_term" style="width: 117px;margin-left:5px" size="mini" placeholder="目前精确结果"
            class="border_box" clearable @change="getList" v-model="current_term"
            :class="current_term == '' ? 'blue' : 'orange'"></el-input>

          <el-input v-if="remtInput" v-model="remtInput" style="width: 117px;margin-left:5px" size="mini"
            placeholder="搜索字" class="border_box" clearable :class="remtInput == '' ? 'blue' : 'orange'"
            @change="getList"></el-input>
          <el-input v-if="time" style="width: 117px;margin-left:5px" size="mini" placeholder="搜索次数" class="border_box"
            clearable @change="getList" v-model="time" :class="time == '' ? 'blue' : 'orange'"></el-input>
          <!-- <el-input style="width: 127px;margin-top: 5px;" size="mini" placeholder="语种" class="border_box"
            clearable></el-input> -->
          <!-- <el-input style="width: 127px;margin-top: 5px;" size="mini" placeholder="搜索时板块" class="border_box"
            clearable></el-input> -->

          <el-input v-if="username" style="width: 117px;margin-left:5px" size="mini" placeholder="昵称" class="border_box"
            clearable @change="getList" v-model="username" :class="username == '' ? 'blue' : 'orange'"></el-input>
          <el-input v-if="remark" style="width: 117px;margin-left:5px" size="mini" placeholder="备注" class="border_box"
            clearable @change="getList" v-model="remark" :class="remark == '' ? 'blue' : 'orange'"></el-input>
          <el-input v-if="ip_addr" style="width: 117px;margin-left:5px" size="mini" placeholder="搜索地区"
            class="border_box" clearable @change="getList" v-model="ip_addr"
            :class="ip_addr == '' ? 'blue' : 'orange'"></el-input>
          <el-switch style="width: 160px;margin-left: 10px;" v-model="anniu" active-color="#13ce66"
            inactive-color="#ff4949" active-text="展开" inactive-text="折叠" @change="getList">
          </el-switch>
          <!-- <el-dropdown @command="RechargeEvt" class="num_box  ">
            <el-button type="primary" size="mini" :class="RechargeName !== '请选择' ? 'vip-button' : 'selt'">
              {{ RechargeName }}<i class="el-icon-arrow-down el-icon--right"></i>
              <i class="el-icon-circle-close   clear_ev" @click="clearEvt1" v-show="RechargeName !== '请选择'"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">参考图</el-dropdown-item>
              <el-dropdown-item command="2">PS</el-dropdown-item>
              <el-dropdown-item command="3">模型</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </div>
        <div>
          <div class="pagination_box">
            <el-input v-model="paginationInput" style="width: 50px" size="mini" @change="limitEvt"
              placeholder="to"></el-input>
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
              :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total" :pager-count="5"
              :show-total="showTotal">
            </el-pagination>
          </div>
        </div>
      </div>

      <div>
        <div style="margin-top: 60px;overflow: unset;border-bottom: 1px solid #e1e1e1; margin-top: 1px solid #e1e1e1;">
          <el-table ref="sortTable" :data="tableData" :cell-style="rowStyle" :summary-method="getSummaries" height="55%"
            :empty-text="dataLoaded ? '暂无数据' : '正在加载数据中...'" @sort-change="sortChangeEvt" show-summary
            style="width: 100%; margin-top: 40px; overflow: none">
            <el-table-column sortable="custom" prop="names" label="搜索字" width="200" align="center">
            </el-table-column>
            <el-table-column sortable="custom" prop="time" width="160" label="搜索次数" align="left">
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="100" label="语种" align="center">
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="150" label="搜索时板块" align="center">
              <span>模型</span>
            </el-table-column>
            <el-table-column sortable="custom" prop="initial_term" width="150" label="当初精准确认" align="center">
            </el-table-column>
            <el-table-column sortable="custom" prop="current_term" width="150" label="目前精准结果" align="center">
            </el-table-column>
            <el-table-column sortable="custom" prop="username" width="100" label="昵称" align="center">
            </el-table-column>
            <el-table-column sortable="custom" prop="remark" width="150" label="备注" align="center">
            </el-table-column>
            <el-table-column sortable="custom" prop="create_time" width="150" label="搜索时间" align="center">
              <template slot-scope="props">
                <div style="width: 100%; display: flex;justify-content: center;">
                  <span style="width: 80px;display: flex;line-height: 30px;"> {{ props.row.create_time }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="ip_addr" label="搜索地区" align="left">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible_one" width="1400" custom-class="sousuo" :show-close="false">
      <div style="height:300px;">
        <span
          style="width: 69px;border: 1px solid #589ff9;height: 26px;font-size: 12px;line-height: 26px;color: #589ff9;border-radius: 3px;cursor: pointer;display: flex;justify-content: center;margin: 0 40px 30px;"
          @click="cleanUpEvt">ALL</span>
        <div style="height:300px;display:flex">
          <div>
            <div class="all_input">
              <span>当初精准确认</span>
              <el-input style="width: 137px;margin-top: 5px;" size="mini" placeholder="请选择" class="border_box"
                clearable @change="getList" v-model="initial_term"
                :class="initial_term == '' ? 'blue' : 'orange'"></el-input>
            </div>
            <div class="all_input">
              <span>目前精确结果</span>
              <el-input style="width: 137px;margin-top: 5px;" size="mini"  placeholder="请选择"  class="border_box" clearable
                @change="getList" v-model="current_term" :class="current_term == '' ? 'blue' : 'orange'"></el-input>
            </div>

            <div class="all_input">
              <span>搜索字</span>
              <el-input v-model="remtInput" style="width: 137px;margin-top: 5px;" size="mini" placeholder="请选择"
                class="border_box" clearable :class="remtInput == '' ? 'blue' : 'orange'" @change="getList"></el-input>
            </div>
            <div class="all_input">
              <span>搜索次数</span>
              <el-input style="width: 137px;margin-top: 5px;" size="mini" placeholder="请选择" class="border_box"
                clearable @change="getList" v-model="time" :class="time == '' ? 'blue' : 'orange'"></el-input>
            </div>
          </div>
          <div>

            <div class="all_input">
              <span>昵称</span>
              <el-input style="width: 137px;margin-top: 5px;" size="mini" placeholder="请选择" class="border_box" clearable
                @change="getList" v-model="username" :class="username == '' ? 'blue' : 'orange'"></el-input>
            </div>
            <div class="all_input">
              <span>备注</span>
              <el-input style="width: 137px;margin-top: 5px;" size="mini" placeholder="请选择" class="border_box" clearable
                @change="getList" v-model="remark" :class="remark == '' ? 'blue' : 'orange'"></el-input>
            </div>
            <div class="all_input">
              <span>搜索地区</span>
              <el-input style="width: 137px;margin-top: 5px;" size="mini" placeholder="请选择" class="border_box"
                clearable @change="getList" v-model="ip_addr" :class="ip_addr == '' ? 'blue' : 'orange'"></el-input>
            </div>
          </div>
          <div>
            <div class="all_input">
              <span>搜索日期</span>
              <el-date-picker v-model="value2" type="daterange" start-placeholder="搜索日期" value-format="timestamp"
                end-placeholder="" align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                range-separator="-" style="width: 137px;margin-top: 5px;" @change="getList" class="border_box"
                :class="{ 'your-css-class': !isValue2Empty }">
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Search1IcoMeLabelApi } from "../../../apis/income"
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  data() {
    return {
      header: true,
      src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      //备注
      remtInput: "",
      time:'',
      initial_term:'',
      current_term:'',
      username:'',
      remark:'',
      ip_addr:'',
      anniu:false,
      dialogVisible_one: false,

      authorIdInput: "",
      localInput: "",
      last_login: "",
      //分页输入框数据
      paginationInput: 10,
      currentPage1: 1,
      type: 4,
      //分页总数据
      total: null,
      sum: null,
      value2: "",
      isValue2Empty: true,
      RechargeName: '请选择',
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
              picker.$emit('pick', [new Date(start.setHours(0, 0, 0, 0)), new Date(end.setHours(23, 59, 59, 0))]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              // picker.$emit("pick", [firstDate, lastDate]);
              picker.$emit('pick', [new Date(firstDate.setHours(0, 0, 0, 0)), new Date(lastDate.setHours(23, 59, 59, 0))]);

            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              // picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
              picker.$emit('pick', [new Date(thisMonthStartDate.setHours(0, 0, 0, 0)), new Date(thisMonthEndDate.setHours(23, 59, 59, 0))]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              // picker.$emit("pick", [startTime, endTime]);
              picker.$emit('pick', [new Date(startTime.setHours(0, 0, 0, 0)), new Date(endTime.setHours(23, 59, 59, 0))]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const temp = new Date();
              temp.setTime(temp.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [new Date(temp.setHours(0, 0, 0, 0)), new Date(temp.setHours(23, 59, 59, 0))]);
            }
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit('pick', [new Date(firstDate.setHours(0, 0, 0, 0)), new Date(lastDate.setHours(23, 59, 59, 0))]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      laiyuan: null,
      input: "",
      editShowInp: null,
      editName: null,
      tableData: [],
      totalRow: null,
      //排序
      order: null,
      orField: null,
      activeId: null,
      deleteVisible: false,
      data: {},
      num: null,
      count: 0,
      pagefenye: false,//点击分页 滚动条为0
      loading: false,
      dataLoaded: false, // 表格数据是否加载完成的状态
      c: 1,
    };
  },
  created() {
    this.loading = true
    if (this.$store.getters.location == '') {
      this.c = 1
    }
    this.c = this.$store.getters.location;

    Search1IcoMeLabelApi({
      c: this.c ,
      fold: this.anniu ? 2 : 1,

    }).then((res) => {
      this.tableData = res.data.search;
      this.total = res.data.total;
      this.sum = res.data.sum;
      this.paginationInput = res.data.limit;
      this.loading = false
    });

    //监听鼠标按下抬起事件
    window.addEventListener("keydown", this.handKeyCode, true);
    window.addEventListener('keyup', this.handKeyEvt);
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁
    window.removeEventListener("keydown", this.handKeyCode, false);
    window.removeEventListener("keyup", this.handKeyEvt, false);
  },
  mounted() {
    //监听页面滚动条事件
    window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);
    this.c = this.$store.getters.location;
  },
  methods: {

    //分页只显示前三页加总数
    showTotal(total) {
      return `共 ${total} 页`;
    },
    //按下键盘事件
    handKeyCode(e) {
      e = e || window.event;
      //Page Up 翻页
      if (e.keyCode == 34) {
        if (this.allLabel == true) {
          return;
        }
        if (
          this.dialogVisible == true ||
          this.searchLabelDialog == true ||
          this.rightLabelDialog == true ||
          this.deleteVisible == true ||
          this.uploadVisible == true
        ) {
          e.preventDefault();
          this.arrowRightEvt()
          this.inputValue_box = ''
          return;
        }
        this.loading = true
        e.preventDefault();
        delay(() => {
          this.currentPage1++;
          this.getList()
        }, 300);
      }
      // Page Down向后分页
      if (e.keyCode == 33) {
        this.loading = true
        delay(() => {
          if (this.currentPage1 <= 1) {
            this.currentPage1 = 1;
          } else {
            this.currentPage1--;
          }
          this.getList()
        }, 300);
      }
    },

    limitEvt() {
      this.getList();
    },
    //滑动事件
    imgScrollEvt(e) {
      var e =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        e ||
        document.body.scrollTop;
      //点击分页 滚动条为0
      if (this.pagefenye == true) {
        e.scrollTop = 0;
        this.pagefenye = false
        return
      }

    },
    //分页
    handleCurrentChange(res) {
      this.loading = true
      setTimeout(() => {
        this.getList()
        this.loading = false
      }, 500)
    },
    //
    rowStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label == "等级") {
        return {};
      } else if (column.label == "昵称") {
        return {};
      }
    },
    //列表排序
    sortChangeEvt(row) {
      if (row.order == "ascending") {
        this.order = "asc";
      } else if (row.order == "descending") {
        this.order = "desc";
      }
      this.orField = row.prop;
      this.getList();
    },
    //显示修改输入框
    editShowEvt(e, s) {
      this.editShowInp = e.id;
      this.editName = s;
      this.$nextTick((_) => {
        this.$refs.editInput.$refs.input.focus();
      });
    },


    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        for (let key in this.totalRow) {
          if (column.property == key) {
            sums[index] = this.totalRow[key];
          }
        }
        if (index === 1) {
          sums[index] = this.sum;
          return;
        }

      });
      return sums;
    },
    //点数情况
    RechargeEvt(res) {
      switch (res) {
        case "1":
          this.RechargeName = "参考图";
          break;
        case "2":
          this.RechargeName = "PS";
          break;
        case "3":
          this.RechargeName = "模型";
          break;
      }
      this.recharge = res;
      this.getList();
    },
    //获取页面数据
    getList() {
      let date = {
        start: this.value2[0],
        end: this.value2[1],
      };
      var start = Math.floor(date.start / 1000);
      var end = Math.floor(date.end / 1000);
      // 将选定的日期转换为当天的最后一秒
      var lastVaccineDate = new Date(end * 1000);
      lastVaccineDate.setHours(23, 59, 59);
      var endTimestamp = Math.floor(lastVaccineDate.getTime() / 1000);
      Search1IcoMeLabelApi({
        start: start ||'',
        end: endTimestamp ||'',
        type: this.recharge,
        names: this.remtInput,
        page: this.currentPage1,
        orField: this.orField,
        orWhere: this.order,
        limit: this.paginationInput,
        time: this.time,
        initial_term: this.initial_term,
        current_term: this.current_term,
        username: this.username,
        remark: this.remark,
        ip_addr: this.ip_addr,
        fold: this.anniu ? 2 : 1,

        c: this.c
      }).then((res) => {
        this.tableData = res.data.search;
        this.total = res.data.total;
        this.totalRow = res.totalRow;
        this.sum = res.data.sum;
        this.pagefenye = true;  //点击分页 滚动条为0
        let as = document.querySelector('.el-table__body-wrapper')
        as.scrollTop = 0
        this.imgScrollEvt(as)
        this.loading = false;
        this.dataLoaded = true; // 数据加载完成，修改dataLoaded的状态
      });
    },
    //清除搜索条件
    cleanUpEvt() {
      this.authorIdInput = ''
      this.remtInput = ''
      this.value2 = ''
      this.RechargeName = '请选择'
      this.currentPage1 = 1
      this.time = ''
      this.initial_term = ''
      this.current_term = ''
      this.username = ''
      this.remark = ''
      this.ip_addr = ''
      this.anniu = false
      this.$refs.sortTable.clearSort();
      Search1IcoMeLabelApi({
        c: this.c
      }).then((res) => {
        this.tableData = res.data.search;
        this.paginationInput = res.data.limit;
        // this.currentPage1 = res.page ;
        this.total = res.data.total;
        this.sum = res.data.sum;
        this.pagefenye = true;  //点击分页 滚动条为0
        let as = document.querySelector('.el-table__body-wrapper')
        as.scrollTop = 0
        this.imgScrollEvt(as)
        this.loading = false;

      });
    },

    clearEvt1() {
      this.RechargeName = '请选择';
      AdminIcoMeLabelApi({
        c: this.c
      }).then((res) => {
        this.tableData = res.data.order;
        this.total = res.total;
        this.totalRow = res.totalRow;
      });
    },
    clearEvt2() {
      this.remtInput = ''
    }
  },
  //点击X后清理数据后并更改值
  computed: {

  },
  watch: {
    '$store.getters.location': function (newLocation, oldLocation) {
      this.c = newLocation
    },
    'value2': function (newVal, oldVal) {
      this.isValue2Empty = !newVal;
    },
  }
};
</script>

<style lang="less" scoped>
@import url("../../../style/space.less");
@import url("../../../style/income.less");
/deep/.el-table th.el-table__cell{
  background: #F5F7FA !important;
}
.item {
  margin-top: 10px;
}

/deep/.el-input__suffix {
  color: #409eff;
}

/deep/.el-main {
  overflow: unset !important;
}

.search_box {
  position: absolute;
  top: 20px;
  left: 50px;
  width: 320px;
  height: 470px;
  border-radius: 10px;
  background-color: #fff;
  display: flex;
  justify-content: space-evenly;
  z-index: 999;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 20px 10px;
  box-shadow: 0 0 10px 1px #e5e5e5;

  /*visibility: hidden;*/
  .num_box {
    width: 127px;
    border: 1px solid #e4e3e3;
    border-radius: 3px;
    margin-top: 5px;
  }
}

.all_text {
  background-color: #409eff;
  font-size: 13px;
  color: #fff;
  cursor: pointer;
  padding: 5px 20px;
  border-radius: 3px;
  width: 50px;
}

.caoz {
  margin-top: 8px;
  display: flex;
}

/* .block {
    position: absolute;
    margin-top: 9px;
    top: 0;
    right: 1%;
    transition: all 0.2s ease 0.5s;
  } */
.block {
  position: fixed;
  right: calc(100% - 99.4%);
  top: 70px;
}

.block1 {
  visibility: hidden;
}

.block1>div {
  display: none;
}

.clear {
  position: relative;
  height: 50px;

  span:nth-last-child(1) {
    background-color: #fff;
    border: 1px solid #e5e5e5;
    font-size: 13px;
    color: #c4c3c3;
    border-radius: 3px;
    position: absolute;
    right: 5px;
    bottom: -6px;
    padding: 0 10px;
    cursor: pointer;
  }

}


.demo-table-expand {
  background-color: #f2f2f2;
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  padding: 0 20px;
  width: 30%;
}

.name_box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  i {
    cursor: pointer;
    display: none;
  }
}

.name_box:hover>i {
  display: block;
}

.pagination_box {
  min-width: 300px;
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-right: 15px;
}

.num_box button {
  width: 125px;
  border: 1px solid #858585;
  background-color: #fff;
  color: #c4c3c3;
}



.rowClassOne {
  background-color: #e7ecff;
}

.rowClassTwo {
  color: #222222;
  background-color: #1c43ce;
}

.rowClassThree {
  background-color: #6a88f1;
}

.el-dropdown-link {
  cursor: pointer;
}

.notes_box {
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.my-icon {
  cursor: pointer;
  width: 25px;
}

/deep/.el-table thead {
  font-size: 12px;
}



/deep/.el-table__footer-wrapper {
  position: fixed;
  top: 110px;
  z-index: 111;
}

/deep/.el-table__fixed-footer-wrapper {
  display: none;
}

/deep/.el-badge__content.is-fixed {
  display: none;
}

/deep/.el-input__inner {
  color: #409eff;
  cursor: pointer;
}

.clear_ev {
  position: absolute;
  right: 10px;
}

.vip-button {
  color: #000 !important;
  background-color: #bcd9f8d4 !important;

}

.span_box_two {
  z-index: 889;
  width: calc(100% - 675px);
  height: 50px;
  border: 1px solid #F5F7FA;
  position: fixed;
  right: 0px;
  background: #F5F7FA;
  border: none;
  top: 109px;
}

.span_box {
  position: absolute;
  right: 1px;
  z-index: 999;
  height: auto;
  background-color: #F5F7FA;
  min-width: 240px;
  height: 48.6px;
  top: 39px;
  z-index: 9991;
  border: 1px solid #f5f7fa;
}

.blur {
  background-color: #fff;
}

/* 朝上排序样式 */
/deep/.el-table .ascending .sort-caret.ascending {
  background-color: #f00 !important;
  background: url("../../../img/12.png")no-repeat -4px -3px  !important;
  background-size: 11px 14px !important;
  width: 40px;
  height: 58px;
  z-index: 11;
}

/* 朝下排序样式 */
/deep/.el-table .descending .sort-caret.descending {
  background: url("../../../img/22.png")no-repeat -5px 2px !important;
  background-size: 11px 14px !important;
  width: 40px;
  height: 25px;

}

/deep/.el-table .descending .sort-caret.descending {
  border-top-color: #fff;
}

/* 朝上字体样式 */
/deep/.el-table__header .ascending .cell {
  color: #409EFF!important;
}

/* 朝下字体样式 */
/deep/.el-table__header .descending .cell {
  color: #409EFF!important;
}

.your-css-class {
  background-color: #bcd9f8d4 !important;
  z-index: 9999;

  input {
    background-color: #bcd9f8d4 !important;
  }
}

.your-css-class_box {
  background-color: #bcd9f8d4 !important;

  input {
    background-color: #bcd9f8d4 !important;
  }
}

.orange {
  /deep/.el-input__inner {
    background-color: #bcd9f8d4 !important;
    color: #222222;
  }

  /deep/.el-input__suffix {
    color: #222222;
  }

}

/deep/.el-input__inner {
  border: none;
}

//调整日期选择器的盒子大小进行修改
/deep/.el-range-editor--mini {
  height: 37px !important;
}


.all_input {
  margin-top: 10px;
  margin-left: 15px;
  display: flex;
  align-items: center;

  span {
    width: 70px;
    font-size: 11px;
    text-align: end;
    margin-right: 10px;
  }

  .el-input {
    width: 160px;
    border: 1px solid;
    border-radius: 5px;
  }

  .el-select {
    border: 1px solid;
    border-radius: 5px;
  }
}


/deep/.sousuo .el-dialog__header{
  padding: 0px 20px 10px !important;
}
/deep/.sousuo{
  border-radius: 8px !important;
}
/deep/.border_box .el-input__inner{
  height: 35px !important;
  line-height: 35px !important;
}
</style>
<style>
.your-css-class .el-range-input {
  background-color: #8fc6ff00 !important;
}

.your-css-class_box .el-range-input {
  background-color: #8fc6ff00 !important;
}

.selt {
  color: #909399 !important;
}

::placeholder {
  color: #858585 !important;
}

.border_box {
  border: 1px solid #858585 !important;
  border-radius: 5px;
  height:37px !important
}

</style>



// WEBPACK FOOTER //
// src/record/components/Search_Records_dang/index.vue